<div class="container-fluid login-page">
  <div id="main-container">
    <div id="logo">
      <img src="assets/images/llwr.png" alt="logo" class="logo" />
      <div id="inner-container">
        <h1 class="title-color">Visual Logistics</h1>
        <div class="row vertical-center login-wrapper">
          <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 vehiclecontainer">
            <div class="vehicle">
              <img class="vertAlign" src="assets/images/containers.png">
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12">
            <p>&nbsp;</p>
          </div>
          <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 login-box ">
            <div id="login">
              <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
                <div class="row form-group">
                  <div class="col-lg-4 col-md-4 col-sm-5 col-xs-5">
                    <label for="lgnControl_UserName" class="fontWeg100">Old Password :</label>
                  </div>
                  <div class="col-lg-8 col-md-8 col-sm-7 col-xs-7 text-center">
                    <input [type]="type" formControlName="oldPassword" class="form-control">
                    <i class="far {{icon}} placeholder"class="placeholder" (click)="iconChange()"></i>
                    <div class="alert alert-danger alertStyle"
                      *ngIf="resetForm.get('oldPassword').invalid && (resetForm.get('oldPassword').dirty || resetForm.get('oldPassword').touched)">
                      <ngu-error *ngIf="resetForm.get('oldPassword').hasError('required')">
                        Old password is required</ngu-error>
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-lg-4 col-md-4 col-sm-5 col-xs-5">
                    <label for="lgnControl_Password" class="fontWeg100">New Password :</label>
                  </div>
                  <div class="col-md-8 col-md-8 col-sm-7 col-xs-7 text-center">
                    <input [type]="type2" formControlName="newPassword" class="form-control">
                    <i class="far {{icon2}} placeholder"class="placeholder" (click)="iconChange2()"></i>
                    <div class="alert alert-danger alertStyle"
                      *ngIf="resetForm.get('newPassword').invalid && (resetForm.get('newPassword').dirty || resetForm.get('newPassword').touched)">
                      <ngu-error *ngIf="resetForm.get('newPassword').hasError('required')">
                        New password is required</ngu-error>
                      <ngu-error
                        *ngIf="resetForm.get('newPassword').hasError('pattern') || resetForm.get('newPassword').hasError('moreThanTwice')">
                        -> Minimum length {{minLength}} is required<br>
                        -> Password should have atleast one uppercase, lowercase, number and special character<br>
                        -> Special characters must contain !#$@%&_- <br>
                        -> Same character is not allowed more than twice
                      </ngu-error>
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-lg-4 col-md-4 col-sm-5 col-xs-5">
                    <label for="lgnControl_Password" class="fontWeg100">Confirm Password :</label>
                  </div>
                  <div class="col-md-8 col-md-8 col-sm-7 col-xs-7 text-center">
                    <input [type]="type3" formControlName="confirmPassword" class="form-control">
                    <i class="far {{icon3}} placeholder"class="placeholder" (click)="iconChange3()"></i>
                    <div class="alert alert-danger alertStyle"
                      *ngIf="resetForm.get('confirmPassword').invalid && (resetForm.get('confirmPassword').dirty || resetForm.get('confirmPassword').touched)">
                      <ngu-error *ngIf="resetForm.get('confirmPassword').hasError('required')">
                        Confirm password is required</ngu-error>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <button type="button" class="btn btn-sub" (click)="navigation()">Cancel</button> &nbsp;
                    <button type="submit" [disabled]="resetForm.invalid" class="btn btn-sub">Reset</button>
                  </div>
                </div>
                <div *ngIf="loading">loading...</div>
                <div *ngIf="resetForm.hasError('notSame')"
                  class="txtAlignCenter">New and Confirm Password does not match!</div>
                <div *ngIf="message" class="txtAlignCenter">{{message}}</div>
                <span *ngIf="resetForm.hasError('notSameUserInfo')" class="spanError">
                  Password should not contain first name, last name, address and company name
                </span>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <span class="spcl-text">Powered By</span>
        <img src="assets/images/elogistics.png">
      </div>
    </div>
  </div>
</div>